import React from "react";
import { cn } from "../lib/utils";
import { Button } from "./ui/button";

export const EmptyState = ({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  className,
  testId = "empty-state",
}) => (
  <div
    data-testid={testId}
    className={cn(
      "flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed bg-card px-6 py-12 text-center",
      className
    )}
  >
    {Icon ? (
      <span className="flex h-11 w-11 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <Icon className="h-5 w-5" />
      </span>
    ) : null}
    <h3 className="font-display text-base font-semibold">{title}</h3>
    {description ? (
      <p className="max-w-md text-sm text-muted-foreground">{description}</p>
    ) : null}
    {actionLabel && onAction ? (
      <Button onClick={onAction} data-testid="empty-state-primary-action" className="mt-1">
        {actionLabel}
      </Button>
    ) : null}
  </div>
);

export default EmptyState;
